import { createAsyncThunk } from '@reduxjs/toolkit';

import { SliceNameEnum } from '@app/enums';
import { sharedNocApiClient } from '@app/services/noc-api/noc-api-client';

export const getUserProfile = createAsyncThunk<{ data: null }, { skipRequest?: boolean }>(
    `${SliceNameEnum.UserProfile}/fetch-data`,
    async ({ skipRequest = false } = {}, { rejectWithValue }) => {
        if (skipRequest) {
            return {
                data: null,
            };
        }

        try {
            const apiClient = sharedNocApiClient;
            const userProfileResponse = await apiClient.user.me();
            return { data: userProfileResponse };
        } catch (err) {
            if (err instanceof Error) {
                return rejectWithValue(err.message);
            } else {
                return rejectWithValue('Unknown error occurred');
            }
        }
    },
);
